import { dapCommonLang } from '~/data/common/lang/global'
export let dapLangGlobal = Object.freeze(deepMerge(dapCommonLang, {
  serviceName: {
    ja: 'ひなぎく',
    en: 'HINAGIKU',
  },
  linkToSource: {
    ja: '提供元サイトで表示',
    en: 'View on source site',
  },
  openInSource: {
    ja: '提供元サイトで表示',
    en: 'View on source site',
  },
  openInDatabase: {
    ja: '提供元サイトで表示',
    en: 'View on source site',
  },
  contact: {
    name: {
      ja: 'ひなぎく担当',
      en: 'In charge of HINAGIKU',
    },
    mail: {
      ja: 'hinagiku@ndl.go.jp',
      en: 'hinagiku@ndl.go.jp',
    },
  },
  quickSearchLink: {
    ja: 'ひなぎく内を検索',
    en: 'Search',
  },
  metadata: {
    common: {
      label: {
        ja: 'ひなぎく共通メタデータ',
        en: 'HINAGIKU Common Meta data',
      }
    }
  },
  datasource: {
    ja: 'データの提供元',
    en: 'Data source',
  },
  db: {
    recordCount: {
      ja: 'メタデータ数',
      en: 'Record',
    },
  },

  // フッター（ひなぎく）
  footer: {
    about: {
      ja: '{}とは',
      en: 'About {}',
    },
    nationalDietLibraryHomePage: {
      ja: '国立国会図書館ホームページ',
      en: 'National Diet Library',
    },
    ndlSearch: {
      ja: '国立国会図書館サーチ',
      en: 'NDL Search',
    },
    news: {
      ja: 'お知らせ',
      en: 'News',
    },
    contact: {
      ja: 'お問い合わせ',
      en: 'Contact Us',
    },
  },

  // ヘッダー
  header: {
    hinagiku: {
      ja: 'ひなぎく 国立国会図書館東日本大震災アーカイブ',
      en: 'HINAGIKU National Diet Library Great East Japan Earthquake Archive',
    },
    language: {
      ja: 'English',
      en: '日本語',
    },
    help: {
      ja: 'ヘルプ',
      en: 'Help',
    },
    gallery: {
      ja: 'ギャラリー',
      en: 'Gallery',
    },
  },

  // 公開状態の変更
  publicationChange: {
    displayed: {
      ja: '{}上で表示され、検索が可能となります。',
      en: 'Displayed and searchable on {}.',
    },
  },

  // トップ
  top: {
    aboutHinagiku: {
      ja: '「{}」とは',
      en: 'About {}',
    },
    hinagikuGarelly: {
      ja: '{}ギャラリー',
      en: '{} Gallery',
    },
    browseByTheme: {
      ja: 'テーマで資料を探す',
      en: 'Browse by theme',
    },
    searchByMap: {
      ja: '地図で探す',
      en: 'Browse by Map',
    },
    newsList: {
      ja: 'お知らせ一覧',
      en: 'News List',
    },
  },

  // 横断検索
  crossSearch: {
    relatedItems: {
      ja: '関連する資料',
      en: 'Related items',
    },
    searchItems: {
      ja: '資料の検索',
      en: 'Search items',
    },
    searchDigitalMaterials: {
      ja: 'デジタル資料の全文検索',
      en: 'Full-text search of digital materials',
    },
    searchWebsites: {
      ja: '過去のウェブサイトの全文検索',
      en: 'Full-text search of archived websites',
    },
    searchDigitalArchives: {
      ja: 'デジタルアーカイブの検索',
      en: 'Search digital archives',
    },
    services: {
      ndlSearch: {
        title: {
          ja: '国立国会図書館サーチ',
          en: 'NDL Search',
        },
        description: {
          ja: '国立国会図書館サーチでは、国立国会図書館の所蔵資料やデジタル資料を検索したり、閲覧やコピーを申し込んだり、様々なサービスが利用できます。また、国立国会図書館とデータ連携している全国の図書館の所蔵資料を検索できます。',
          en: 'NDL Search allows you to search for materials and digital materials held by the National Diet Library, You can request for browsing or copying, and use a variety of other services. You can also search for materials held by libraries in Japan with which has data linked.',
        },
      },
      ndlDigitalCollection: {
        title: {
          ja: '国立国会図書館デジタルコレクション',
          en: 'National Diet Library Digital Collections',
        },
        description: {
          ja: '国立国会図書館で収集・保存している資料のうち、デジタル化された資料を検索・閲覧できるサービスです。著作権の保護期間が満了になった資料や、絶版等の理由で入手が困難な資料を、ご自宅の環境からも検索・閲覧いただくことができます。',
          en: 'This service allows users to search for and browse digitized materials that have been acquired and preserved by the National Diet Library. You can search for and browse materials with expired copyright protection or which are difficult to obtain for reasons such as being out of print, etc., from your personal devices.',
        },
      },
      warp: {
        title: {
          ja: '国立国会図書館インターネット資料収集保存事業（WARP）',
          en: 'WARP (Web Archiving Project)',
        },
        description: {
          ja: '2002年より収集されている、日本国内のウェブサイトを検索・閲覧できます。失われやすいウェブサイトに掲載された情報を、収集・保存して未来に伝えていくのが、インターネット資料収集保存事業（Web Archiving Project: WARP）の役割です。',
          en: 'This site allows you to search and browse websites in Japan that have been collected since 2002. The role of the Web Archiving Project (WARP) is to collect, preserve, and pass on to the future information on websites that are easily lost.',
        },
      },
      japanSearch: {
        title: {
          ja: 'ジャパンサーチ',
          en: 'Japan Search',
        },
        description: {
          ja: '書籍・公文書・文化財・美術・人文学・自然史/理工学・学術資産・放送番組・映画など、我が国が保有する様々な分野のコンテンツのメタデータを検索・閲覧・活用できるプラットフォームです。',
          en: 'Japan Search is a national platform for aggregating metadata of digital resources of various fields and operated by the National Diet Library, Japan, in cooperation with a variety of organizations in Japan under policies established by the Study Group for Promoting Digital Archiving.',
        },
      },
    },
    
    // 所蔵種別
    holdingType: {
      internet: {
        ja: 'インターネットで読める',
        en: 'Available online',
      },
      ndl: {
        ja: '国立国会図書館',
        en: 'National Diet Library',
      },
      library: {
        ja: '全国の図書館',
        en: 'Other Libraries in Japan',
      },
    },
  },

  // 統計
  stats: {
    database: {
      category: {
        ja: 'カテゴリー',
        en: 'Category',
      }
    }
  },
}))
